import { NameAndCode } from '@/fetching/sharedSchemas/basicSchemas';

export enum Language {
    ENGLISH = 'ENGLISH',
    SPANISH = 'SPANISH',
    KHMER = 'KHMER',
    VIETNAMESE = 'VIETNAMESE',
    CHINESE = 'CHINESE',
    FRENCH = 'FRENCH',
    ARABIC = 'ARABIC',
    PERSIAN = 'PERSIAN',
    TAGALOG = 'TAGALOG',
    URDU = 'URDU',
    KOREAN = 'KOREAN',
    RUSSIAN = 'RUSSIAN',
    GERMAN = 'GERMAN',
}

export const renderLanguage = (language: Language): string => {
    switch (language) {
        case Language.ENGLISH:
            return 'English';
        case Language.SPANISH:
            return 'Spanish';
        case Language.KHMER:
            return 'Khmer';
        case Language.VIETNAMESE:
            return 'Vietnamese';
        case Language.CHINESE:
            return 'Chinese';
        case Language.FRENCH:
            return 'French';
        case Language.ARABIC:
            return 'Arabic';
        case Language.PERSIAN:
            return 'Persian';
        case Language.TAGALOG:
            return 'Tagalog';
        case Language.URDU:
            return 'Urdu';
        case Language.KOREAN:
            return 'Korean';
        case Language.RUSSIAN:
            return 'Russian';
        case Language.GERMAN:
            return 'German';
        default:
            throw new Error(`Unknown language: ${language as string}`);
    }
};

// Temp: conversion between graphql and zod types
export const languageToCode = (language: Language): string => {
    switch (language) {
        case Language.ENGLISH:
            return 'en';
        case Language.SPANISH:
            return 'es';
        case Language.KHMER:
            return 'km';
        case Language.VIETNAMESE:
            return 'vi';
        case Language.CHINESE:
            return 'zh';
        case Language.FRENCH:
            return 'fr';
        case Language.ARABIC:
            return 'ar';
        case Language.PERSIAN:
            return 'fa';
        case Language.TAGALOG:
            return 'tl';
        case Language.URDU:
            return 'ur';
        case Language.KOREAN:
            return 'ko';
        case Language.RUSSIAN:
            return 'ru';
        case Language.GERMAN:
            return 'de';
        default:
            throw new Error(`Unknown language: ${language as string}`);
    }
};

// Temp: conversion between graphql and zod types
export const languageToZod = (language: Language): NameAndCode => {
    return { code: languageToCode(language), name: renderLanguage(language) };
};

export const availableLanguages = Object.values(Language).map(languageToZod);
